import { isSafeUrl } from './safeUrl';

/**
 * Starts the OAuth redirect to the given provider. Shared by Login (explicit
 * provider choice) and Landing (skips straight to the only configured
 * provider) so the redirect/callback URL construction can't drift between
 * the two call sites.
 */
export const startOAuthLogin = (provider: string, authServerUrl: string): void => {
  const currentOrigin = window.location.origin;
  // Get the base path from the <base> tag or default to '/'
  const baseElement = document.querySelector('base');
  const basePath = baseElement?.getAttribute('href') || '/';
  // Must point at the registry's own /api/auth/auth/callback (not just the
  // base path): that handler is what actually runs the post-login
  // role-sync and bank-transactions hooks before redirecting on to "/".
  // Redirecting straight to the base path skipped those hooks entirely
  // (security review finding, 2026-10-28).
  const callbackPath = `${basePath.replace(/\/$/, '')}/api/auth/auth/callback`;
  const redirectUri = encodeURIComponent(currentOrigin + callbackPath);

  // authServerUrl comes from /api/auth/config (server-supplied), so treat it
  // as untrusted: only navigate to an http/https base, never a
  // javascript:/data: scheme. Fall back to the safe default otherwise.
  const configuredAuthUrl = authServerUrl && isSafeUrl(authServerUrl) ? authServerUrl : 'http://localhost:8888';
  window.location.href = `${configuredAuthUrl}/oauth2/login/${provider}?redirect_uri=${redirectUri}`;
};
